import { sections } from '../data/sections';
import '../components/TimelineItem.css';

const AboutSection = () => {
  return (
    <article className="about-article" itemScope itemType="https://schema.org/Person">
      <meta itemProp="name" content="Sidharth Sudhir" />
      <meta itemProp="jobTitle" content="Software Engineer" />
      <meta itemProp="worksFor" content="BlackRock" />
      <meta itemProp="alumniOf" content="University of California, Los Angeles" />

      {sections.map((section) => {
        const isAboutSection = section.title === 'about';
        const isTimelineSection = section.title === 'timeline';
        const isProjectsSection = section.title === 'projects';

        return (
          <section
            key={section.title}
            id={section.title}
            className="content-section"
            aria-labelledby={`section-${section.title}`}
            {...(isAboutSection && { itemProp: "description" })}
            {...(isTimelineSection && { itemProp: "hasOccupation", itemScope: true, itemType: "https://schema.org/OrganizationRole" })}
            {...(isProjectsSection && { itemProp: "hasCredential", itemScope: true, itemType: "https://schema.org/EducationalOccupationalCredential" })}
          >
            <h2 id={`section-${section.title}`} className="section-title">
              {section.title}
              {section.subtitle && (
                <span className="section-subtitle">{section.subtitle}</span>
              )}
            </h2>
            <div className="section-content">
              {section.content}
            </div>
          </section>
        );
      })}
    </article>
  );
};

export default AboutSection;
